module.exports = __webpack_public_path__ + "static/media/map-mobile.41b0b5ed.svg";